import React, { useState, useEffect, useRef } from 'react';
import { connect } from "react-redux";

import NavBar from '../navigation/NavBar';
import LoginNavBar from '../navigation/LoginNavBar';

import IsConnected from './IsConnected';
import AboutWebUI from './AboutWebUI';
import AboutTkggbs from './AboutTkggbs';

const WelcomePage = ({
  loginResult
}) => {
  const ref = useRef(null);

  const [ finetune, setFinetune ] = useState({
    finetuneX: window.innerWidth,
    finetuneY: window.innerHeight,
  });

  const handleResize = () => {
    setFinetune({
      finetuneX: window.innerWidth,
      finetuneY: window.innerHeight
    });
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, [window.innerWidth, window.innerHeight]);

  window.scrollTo(0, 0);

  return (
    <div ref={ref} className='sans-serif h-100 bg-navy'>
      <div className='bg-navy'>
        { loginResult
          ? <div className='navbar-container flex-none-l bg-custom-navy-20' style={{ height: '100%' }}>
              <NavBar />
            </div>
          : <div className='navbar-container flex-none-l bg-custom-navy-20' style={{ height: '100%' }}>
              <LoginNavBar />
            </div>}
        <div className='flex-auto-l bg-navy'>
          <IsConnected />
          <div className='flex-360 justiry-center ml4 mr4'>
            <div className='lh-copy mr3 mid-gray w-50-ns'>
              <AboutWebUI />
            </div>
            <div className='lh-copy ml3 mid-gray w-50-ns mt3 mt0-ns'>
              <AboutTkggbs />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  loginResult: state.login.loginResult
});

export default connect(mapStateToProps)(WelcomePage);
